import { URI_GUARD_REQUEST } from '@/config/config';

export default async ({ rootState }, payload) => {
  const toasted = payload.toasted
  const licencePlate = payload.licencePlate
  delete payload.toasted
  delete payload.licencePlate

  try {
    const token = rootState['DATA-ACCESS'].tokenAuth;
    const userToken = rootState['DATA-ACCESS'].userToken;
    const opts = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'user-token': userToken
      },
      body: JSON.stringify(payload),
    };
    let path = `${URI_GUARD_REQUEST}serpro/send-to-serpro`;
    const response = await fetch(path, opts);
  
    const jsonResult = await response.json();
  
    if (jsonResult.status === 'error' || !jsonResult.success) {
      toasted.error(jsonResult.message);
      return Promise.reject(jsonResult.message);
    }
    
    toasted.success(`Placa ${licencePlate} enviada para a SERPRO com sucesso`);
    // return jsonResult
  } catch (error) {
    toasted.error(error);
    return Promise.reject(error);
  }
};
